import React from "react";

import { CrossIcon } from "@/assets/icons";
import { cn } from "@/lib/cn";

interface ClearInputValueButtonProps {
  className?: string;
  title: string;
  onClick: () => void;
}
export const ClearInputValueButton = (props: ClearInputValueButtonProps) => {
  const { className, title, onClick } = props;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    onClick();
  };

  return (
    <button
      aria-label={title}
      className={cn(
        "absolute right-3 top-1/2 flex -translate-y-1/2 cursor-pointer border-none bg-transparent p-0 text-muted-foreground hover:text-primary-fg focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring [&_svg]:h-2.5",
        className,
      )}
      title={title}
      tabIndex={-1}
      onClick={handleClick}
      type="button"
    >
      <CrossIcon />
    </button>
  );
};
